export const AmlListTypeEnum = {
  sanction: 'sanction',
  warning: 'warning',
  fitness_probity: 'fitness_probity',
  pep: 'pep',
  adverse_media: 'adverse_media',
} as const;
export type AmlListTypeEnum =
  (typeof AmlListTypeEnum)[keyof typeof AmlListTypeEnum];
